import { Controller } from "@hotwired/stimulus";

// Collapses the payment-method list to the first few cards behind a
// "See More" / "See Less" toggle (Figma "Excess CC's" state).
export default class extends Controller {
  static targets = ["extra", "label", "icon"];

  connect() {
    this.expanded = false;
    this.update();
  }

  toggle(event) {
    event.preventDefault();
    this.expanded = !this.expanded;
    this.update();
  }

  update() {
    this.extraTargets.forEach((el) => {
      el.style.setProperty("display", this.expanded ? "" : "none", "important");
    });
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.expanded ? "See Less" : "See More";
    }
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.expanded ? "rotate(180deg)" : "";
    }
  }
}
